// External dependencies.
import { LitElement, html, css } from "lit";

// Internal dependencies.
import { sharedStyles } from "./styles/shared-styles";

/**
 * AppInstagram component class.
 *
 * @since 0.1.0
 * @deprecated 1.7.1
 * @class AppInstagram
 * @extends {LitElement}
 */
class AppInstagram extends LitElement {
    /**
     * Inits the component's properties.
     *
     * @readonly
     * @static
     * @memberof AppInstagram
     */
    static get properties() {
        return {
            media: { type: Array },
        };
    }

    /**
     * Inits the component's CSS styles.
     *
     * @since 0.1.0
     * @deprecated 1.7.1
     * @readonly
     * @static
     * @memberof AppInstagram
     */
    static get styles() {
        return [ sharedStyles, css`
            .ts-instagram {
                display: flex;
                flex-wrap: wrap;
            }

            .ts-instagram-link {
                position: relative;
                display: block;
                flex-basis: 50%;
            }

            .ts-instagram-link:hover .ts-instagram-link-overlay {
                opacity: 1;
            }

            .ts-instagram-link-overlay {
                opacity: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-color: rgba(0, 0, 0, .4);
                transition: opacity .6s ease-in-out;
            }

            .ts-instagram-link-overlay__icon {
                width: 1.875rem;
                height: 1.875rem;
            }

            .ts-instagram-image {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            @media (min-width: 768px) {
                .ts-instagram-link {
                    flex-basis: 25%;
                }
            }
        `];
    }

    /**
     * Renders the component.
     *
     * @since 0.1.0
     * @deprecated 1.7.1
     * @returns TemplateResult
     * @memberof AppInstagram
     */
    render() {
        return html`
            ${null === this.media || undefined === this.media ? null : html`
                <div class="ts-instagram">
                    ${this.media.map( item => html`
                        <a href="${item.link}" target="_blank" class="ts-instagram-link">
                            <img src="${item.images.standard_resolution.url}" alt="${item.caption.text}" srcset="${item.images.low_resolution.url} 320w, ${item.images.standard_resolution.url} 640w" sizes="(max-width: 320px) 320px, 640px" class="ts-instagram-image">
                            <span class="ts-instagram-link-overlay">
                                <img src="${window.app.theme_file_uri}/assets/images/icon-instagram.svg" class="ts-instagram-link-overlay__icon">
                            </span>
                        </a>
                    `)}
                </div>
            `}
        `;
    }
}

window.customElements.define( 'app-instagram', AppInstagram );
